import {
  Issues as IssuesModule,
  IFI as IFIModule,
} from '../../CIMSModule/instances'
import { CIMSPage } from '../../cimsPage'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const I = 'Issue'
const Is = `${I}s`
const IWF = `${Is} workflow`

export const IssueAdmin = new RoleTemplateItem({
  id: 'fb58baf2-8091-4365-9e05-ab9c0f12d9bb',
  name: `${I} Admin`,
  description: `Gives users access to all permissions within the ${IWF}`,
  module: IssuesModule,
  permissionItems: [
    ...Permission.findByModule(IssuesModule),
    ...Permission.findByModule(IFIModule),
  ],
})

export const IssueCloser = new RoleTemplateItem({
  id: '09590a4c-9a93-43ae-a880-3c521f55b318',
  name: `${I} Closer`,
  description: `Allows users to Close ${Is}`,
  module: IssuesModule,
  permissionItems: [
    Permission.ViewIssue,
    Permission.CreateIssue,
    Permission.EditIssue,
    Permission.CommentOnIssue,
    Permission.CloseIssue,
    Permission.ViewIdentifiedFieldIssue,
    Permission.CommentOnIdentifiedFieldIssue,
    Permission.ViewIssueType,
    Permission.ViewIssueDispositionType,
    Permission.ViewIssueQuickLink,
    ...Permission.findByPage(CIMSPage.IssueNotifications),
    ...Permission.findByPage(CIMSPage.IFINotifications),
  ],
})

export const IssueCreator = new RoleTemplateItem({
  id: 'a7b3e4f9-2c8d-4a6b-9e1f-5c7a8b9d0e2f',
  name: `${I} Creator`,
  description: `Allows users to Create new ${Is}`,
  module: IssuesModule,
  permissionItems: [
    Permission.ViewIssue,
    Permission.CreateIssue,
    Permission.EditIssue,
    Permission.CommentOnIssue,
    Permission.ViewIdentifiedFieldIssue,
    Permission.CommentOnIdentifiedFieldIssue,
    Permission.ViewIssueType,
    Permission.ViewIssueDispositionType,
    Permission.ViewIssueQuickLink,
    Permission.ViewIssueNotification,
    Permission.ViewIFINotification,
  ],
})

export const IssueDispositionGiver = new RoleTemplateItem({
  id: 'b8c4f5a0-3d9e-5b7c-0f2a-6d8b9c0e1f3a',
  name: `${I} Disposition Giver`,
  description: `Gives users access to give ${Is} a disposition`,
  module: IssuesModule,
  permissionItems: [
    Permission.ViewIssue,
    Permission.CreateIssue,
    Permission.EditIssue,
    Permission.CommentOnIssue,
    Permission.RemoveRestoreIssue,
    Permission.RevertIssue,
    Permission.UnlockIssue,
    Permission.GiveIssueDisposition,
    Permission.CloseIssue,
    ...Permission.findByPage(CIMSPage.IFITracker),
    ...Permission.findByPage(CIMSPage.IssueTypes),
    ...Permission.findByPage(CIMSPage.IssueDispositionTypes),
    Permission.ViewIssueQuickLink,
    ...Permission.findByPage(CIMSPage.IssueNotifications),
    ...Permission.findByPage(CIMSPage.IFINotifications),
  ],
})

export const IssueResponder = new RoleTemplateItem({
  id: 'c9d5f6b1-4e0f-6c8d-1a3b-7e9c0d1f2a4b',
  name: `${I} Responder`,
  description: `Gives users access to respond to ${Is}`,
  module: IssuesModule,
  permissionItems: [
    Permission.ViewIssue,
    Permission.CreateIssue,
    Permission.EditIssueResponse,
    Permission.CommentOnIssue,
    Permission.RespondToIssue,
    Permission.ViewIdentifiedFieldIssue,
    Permission.CommentOnIdentifiedFieldIssue,
    Permission.ViewIssueType,
    Permission.ViewIssueDispositionType,
    Permission.ViewIssueQuickLink,
    Permission.ViewIssueNotification,
    Permission.ViewIFINotification,
  ],
})

export type IssuesRoleTemplateItem =
  | typeof IssueAdmin
  | typeof IssueCloser
  | typeof IssueCreator
  | typeof IssueDispositionGiver
  | typeof IssueResponder
